import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { useControlledField, CheckboxField } from '@frontend/design-system';
import { pendoTags } from '../../../../../../../../../shared/constants';
import { useCreateFormStepsStore } from '../../provider';
import { checkboxStyle } from './usage-terms-checkbox.style';

const UsageTermsStepCheckbox: FC = () => {
  const { t } = useTranslation('forms');
  const { areUsageTermsAccepted, setAreUsageTermsAccepted } = useCreateFormStepsStore([
    'areUsageTermsAccepted',
    'setAreUsageTermsAccepted',
  ]);

  const checkboxFieldProps = useControlledField({
    type: 'checkbox',
    value: areUsageTermsAccepted,
    onChange: (newValue: boolean) => {
      setAreUsageTermsAccepted(newValue);
    },
  });

  return (
    <CheckboxField
      {...checkboxFieldProps}
      label={t(
        'By checking this box, I confirm that I have read the above-mentioned disclaimers and agree to the terms outlined.'
      )}
      name=''
      css={checkboxStyle}
      trackingId={pendoTags.templateGallery.usageTerms.select}
    />
  );
};

export default UsageTermsStepCheckbox;
